// 登录相关接口
import request from '@/utils/request'

// 用户登录接口
export function login(data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}


// 获取手机号验证码
export function getVerifysms(data) {
  return request({
    url: '/message/verify/sms',
    method: 'post',
    data
  })
}